export const BUG_REPORT = 'bugReport';
export const IMAGES_REVIEW = 'imagesReview';

export const types = {
  [BUG_REPORT]: '#bug_report_portal',
  [IMAGES_REVIEW]: '#images_review_portal',
};
